module.exports = __webpack_public_path__ + "img/crosshairs-solid.494e6ff2.svg";